import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/ChartPieOutline.tsx
import React from "react";
var SvgChartPieOutline, ChartPieOutline_default;
var init_ChartPieOutline = __esm({
  "src/icons/ChartPieOutline.tsx"() {
    SvgChartPieOutline = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "M12 22C6.477 22 2 17.523 2 12c0-4.478 2.943-8.268 7-9.542v2.124A8.003 8.003 0 0 0 12 20a8.002 8.002 0 0 0 7.418-5h2.124c-1.274 4.057-5.064 7-9.542 7Zm9.95-9H11V2.05c.329-.033.663-.05 1-.05 5.523 0 10 4.477 10 10 0 .337-.017.671-.05 1ZM13 4.062V11h6.938A8.004 8.004 0 0 0 13 4.062Z"
        }
      )
    );
    ChartPieOutline_default = SvgChartPieOutline;
  }
});

export {
  ChartPieOutline_default,
  init_ChartPieOutline
};
